import * as api from '../api/appealCheckIn';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN';

export const FETCH_WORKITEM_TYPES = createRequestTypes(
  `${prefix}/FETCH_WORKITEM_TYPES`,
);

export const fetchWorkItemTypes = makeApiActionCreatorV3(
  api.fetchWorkItemTypes,
  FETCH_WORKITEM_TYPES[START],
  FETCH_WORKITEM_TYPES[SUCCESS],
  FETCH_WORKITEM_TYPES[ERROR],
);

export const CHECKIN_APPEAL = createRequestTypes(
  `${prefix}/CHECKIN_APPEAL`,
);
  
export const checkinAppeal = makeApiActionCreatorV3(
  api.checkinAppeal,
  CHECKIN_APPEAL[START],
  CHECKIN_APPEAL[SUCCESS],
  CHECKIN_APPEAL[ERROR],
);

export const FETCH_CHECKIN_CONFIG = createRequestTypes(
  `${prefix}/FETCH_CHECKIN_CONFIG`,
);
    
export const fetchCheckInConfig = makeApiActionCreatorV3(
  api.fetchCheckInConfig,
  FETCH_CHECKIN_CONFIG[START],
  FETCH_CHECKIN_CONFIG[SUCCESS],
  FETCH_CHECKIN_CONFIG[ERROR],
);

export const FETCH_PROPERTY_LIMITATION_COMPRESSION = createRequestTypes(
  `${prefix}/FETCH_PROPERTY_LIMITATION_COMPRESSION`,
);
    
export const fetchPropertyLimitaionCompression = makeApiActionCreatorV3(
  api.fetchPropertyLimitaionCompression,
  FETCH_PROPERTY_LIMITATION_COMPRESSION[START],
  FETCH_PROPERTY_LIMITATION_COMPRESSION[SUCCESS],
  FETCH_PROPERTY_LIMITATION_COMPRESSION[ERROR],
);

//

export const COMPRESS_PROPERTY_LIMITATION = createRequestTypes(
  `${prefix}/COMPRESS_PROPERTY_LIMITATION`,
);
    
export const compressPropertyLimitation = makeApiActionCreatorV3(
  api.compressPropertyLimitation,
  COMPRESS_PROPERTY_LIMITATION[START],
  COMPRESS_PROPERTY_LIMITATION[SUCCESS],
  COMPRESS_PROPERTY_LIMITATION[ERROR],
);